module.exports = [{"label":"NA","id":"1"},{"label":"CM","id":"2"},{"label":"M2","id":"3"},{"label":"Unid","id":"4"},{"label":"Pixel","id":"5"},{"label":"Polegada","id":"6"},{"label":"Segundos","id":"7"}]


//////////////////
// WEBPACK FOOTER
// ./src/fixtures/unitsOfmeasurement.json
// module id = 137
// module chunks = 0